import TextareaEditor from "./TextareaEditor";

export default TextareaEditor;
export { TextareaEditor };
